<!--
  @file 顶导
-->

<template>
  <header ref="header" class="clearfix">
    <div
      @click="logoClick"
      class="pull-left pointer logo"
      :class="{'hideSidebar': !sidebar.opened}"
    >
      <img
        :src="sidebar.opened
                ? '//htwuhan.oss-cn-beijing.aliyuncs.com/tool/logo@2x.png'
                : '//htwuhan.oss-cn-beijing.aliyuncs.com/tool/logo-mini.png'"
      />
    </div>
    <div class="top-intro-container">
      <div>
        <hamburger :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        <breadcrumb isShowHome homeName="预算管理系统" class="breadcrumb-container"></breadcrumb>
      </div>
      <div style="display: flex;align-items: center">
        <el-dropdown trigger="click" v-if="userInfo.roles && userInfo.roles.length > 1">
          <div class="el-dropdown-trigger">
            <img
              class="avatar"
              v-if="userInfo.avatar"
              :src="(userInfo.avatar||'//htwuhan.oss-cn-beijing.aliyuncs.com/tool/portarit.png')|compressImage(24, 24)"
              width="24"
              height="24"
            />
            <span class="name" v-cloak v-if="userInfo.name">
              {{userInfo.name}}<span class="text-gray-light" v-show="userInfo.curRole && userInfo.curRole.roleName">({{userInfo.curRole.roleName}})</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!--sku中active样式 需满足roleid和nodeid都相等-->
            <el-dropdown-item
              v-for="item in userInfo.roles"
              :key="item.id"
              :class="{'active': item.nodes && item.nodes.length && item.nodes[0]
                            ? userInfo.curRole.roleId == item.roleId && userInfo.curRole.nodes[0].id == item.nodes[0].id
                            : userInfo.curRole.roleId == item.roleId}"
              @click.native="changeRole(item)"
            >
              {{item.roleName}}
              <span
                v-if="item.nodes && item.nodes.length && item.nodes[0]"
                class="text-gray-light role-item-node"
              >[{{item.nodes[0].name}}]</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <template v-else>
          <img
            class="avatar"
            v-if="userInfo.avatar"
            :src="(userInfo.avatar||'//htwuhan.oss-cn-beijing.aliyuncs.com/tool/portarit.png')|compressImage(24, 24)"
            width="24"
            height="24"
          />
          <span class="name" v-cloak v-if="userInfo.name">{{userInfo.name}}({{userInfo.staffNo}})</span>
        </template>
          <!-- @show="popoverShow" -->
        <el-popover
          v-if="openNotification"
          ref="popover"
          placement="bottom-start"
          width="280"
          trigger="click"
        >
          <section v-loading="$store.state.sidebar.loading" class="top-notification-content">
            <h3 class="top-notification-content_title">消息通知</h3>
            <ul v-if="unreadMessageList.length !== 0" class="top-notification-content_list">
              <li
                v-for="(unreadMessageItem, index) of unreadMessageList"
                :key="index"
                @click="setMsgReaded(unreadMessageItem)"
                class="top-notification-content_item"
              >
                <div>
                  <span class="dot" v-if='unreadMessageItem.isRead==0'></span>
                  <el-tooltip class="item" effect="dark" :content="unreadMessageItem.content" placement="bottom">
                    <p class="msg-item pointer" v-tooltip>{{unreadMessageItem.content}}</p>
                  </el-tooltip>
                </div>
              </li>
            </ul>
            <section
              class="top-notification-nothing_container"
              style="min-height: 300px;"
              v-if="!unreadMessageList.length || unreadMessageList.length === 0"
            >
              <div class="top-notification-nothing_icon">
                <svg viewBox="0 0 1024 1024" p-id="1747" width="55" height="55">
                  <path
                    d="M475.829476 1024C551.912302 1024 611.780755 962.884287 611.780755 888.048721H339.878197c0 74.835566 61.115713 135.951279 135.951279 135.951279zM772.677223 140.940317c-102.275274 0-184.594397 63.610231-184.594397 143.434835 0 78.577345 82.319123 143.434836 184.594397 143.434836 102.275274 0 184.594397-63.610231 184.594397-143.434836s-82.319123-143.434836-184.594397-143.434835z m-87.308161 167.132765c-13.719854 0-23.697929-11.225335-23.697929-23.69793 0-13.719854 11.225335-23.697929 23.697929-23.697929 13.719854 0 23.697929 11.225335 23.697929 23.697929 1.247259 13.719854-9.978076 23.697929-23.697929 23.69793z m87.308161 0c-13.719854 0-23.697929-11.225335-23.697929-23.69793 0-13.719854 11.225335-23.697929 23.697929-23.697929s23.697929 11.225335 23.697929 23.697929c0 13.719854-9.978076 23.697929-23.697929 23.69793z m86.060901 0c-13.719854 0-23.697929-11.225335-23.697929-23.69793 0-13.719854 11.225335-23.697929 23.697929-23.697929s23.697929 11.225335 23.69793 23.697929c1.247259 13.719854-9.978076 23.697929-23.69793 23.69793z"
                    p-id="1748"
                  />
                  <path
                    d="M838.781973 750.850183c-44.90134 0-44.90134-180.852619-44.90134-180.852619V462.733252c-6.236297 0-13.719854 1.247259-19.956151 1.24726-122.231425 0-222.01218-81.071864-222.01218-180.852619 0-57.373934 33.676005-108.511571 86.060901-142.187576-22.45067-14.967113-46.148599-26.192448-72.341047-34.923265 1.247259-4.989038 1.247259-9.978076 1.247259-14.967113 0-49.890378-41.159562-91.049939-91.049939-91.049939s-91.049939 41.159562-91.049939 91.049939c0 4.989038 0 9.978076 1.24726 14.967113-125.973203 43.65408-228.248477 178.3581-228.248478 336.760049v124.725944s0 180.852619-43.65408 182.099878c-26.192448 0-46.148599 19.956151-46.1486 44.90134S87.93179 839.405603 112.876979 839.405603h725.904994c24.945189 0 44.90134-19.956151 44.90134-44.90134 1.247259-22.45067-19.956151-43.65408-44.90134-43.65408z m-361.705237-619.887942c-19.956151 0-37.417783-16.214373-37.417784-37.417783 0-19.956151 16.214373-37.417783 37.417784-37.417783 19.956151 0 37.417783 16.214373 37.417783 37.417783-1.247259 21.20341-17.461632 37.417783-37.417783 37.417783z"
                    p-id="1749"
                  />
                </svg>
                <p>暂时无消息通知</p>
              </div>
            </section>
            <!-- <div @click="viewMoreNotifications" class="top-notification-content-bottom">
              <div v-if="unreadMessageList.length || unreadMessageList.length !== 0">
                查看全部
                <i class="el-icon-arrow-right"></i>
              </div>
            </div> -->
          </section>
          <el-badge
            style="margin: 0 5px 0 20px;"
            slot="reference"
            :hidden="!unreadMessageNum"
            :value="unreadMessageNum"
            :max="9"
            class="item"
          >
            <div class="top-notification" title="通知中心">
              <svg viewBox="0 0 1024 1024" width="16" height="16">
                <path
                  d="M694.857143 936.228571h-365.714286c-21.942857 0-36.571429 14.628571-36.571428 36.571429s14.628571 36.571429 36.571428 36.571429h358.4c21.942857 0 36.571429-14.628571 36.571429-36.571429s-7.314286-36.571429-29.257143-36.571429zM936.228571 753.371429l-80.457142-124.342858c-21.942857-43.885714-73.142857-21.942857-65.828572 21.942858V658.285714l80.457143 138.971429v7.314286H146.285714l87.771429-138.971429c0-7.314286 7.314286-7.314286 7.314286-14.628571v-219.428572c0-95.085714 80.457143-197.485714 190.171428-234.057143 29.257143-7.314286 43.885714-14.628571 58.514286-14.628571h58.514286c14.628571 0 36.571429 7.314286 65.828571 14.628571 102.4 36.571429 182.857143 138.971429 182.857143 234.057143v204.8c0 29.257143 65.828571 36.571429 73.142857 0V431.542857c0-58.514286-21.942857-124.342857-65.828571-175.542857-43.885714-43.885714-95.085714-80.457143-146.285715-102.4 0-73.142857-65.828571-131.657143-146.285714-131.657143s-146.285714 58.514286-146.285714 131.657143c-51.2 21.942857-102.4 58.514286-131.657143 102.4-43.885714 58.514286-65.828571 117.028571-65.828572 175.542857v190.171429L87.771429 760.685714c-14.628571 21.942857-14.628571 43.885714 0 65.828572 14.628571 21.942857 36.571429 29.257143 58.514285 29.257143h731.428572c36.571429 0 65.828571-29.257143 65.828571-65.828572 7.314286-7.314286 0-21.942857-7.314286-36.571428zM512 80.457143c36.571429 0 65.828571 21.942857 73.142857 51.2-43.885714-7.314286-102.4-14.628571-146.285714 0 7.314286-29.257143 36.571429-51.2 73.142857-51.2z"
                  p-id="1620"
                />
              </svg>
            </div>
          </el-badge>
        </el-popover>

        <span class="pointer exit" @click="logout" title="退出">
          <icon style="color:#666" name="loginout" scale="1.6"></icon>
        </span>
      </div>
    </div>
  </header>
</template>

<script>
import Hamburger from "./Hamburger";
import Breadcrumb from "./Breadcrumb";
import { postWithJson } from "library/utils/serviceUtil";

export default {
  components: {
    Hamburger,
    Breadcrumb
  },
  props: {
    openNotification: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      scrollX: document.documentElement.scrollLeft || document.body.scrollLeft,
      scrollY: 0
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    sidebar() {
      return this.$store.state.sidebar || {};
    },
    unreadMessageNum() {
      return this.$store.state.sidebar.unreadMessageNum || 0;
    },
    unreadMessageList() {
      return this.$store.state.sidebar.unreadMessageList || [];
    }
  },
  mounted() {
    setTimeout(()=>{
      this.$store.dispatch("getUnreadMessageList");
    }, 2000)
    // console.log("this.unreadMessageList", this.unreadMessageList)
  },
  methods: {
    setMsgReaded(msgData) { // 消息设为已读
      if(msgData.isRead == 1) {
        return
      }
      postWithJson("/message/mod.json", {
        id: msgData.id,
        isRead: 1
      }).then(() => {
        this.$store.dispatch("getUnreadMessageList");
        // this.$message.success()
      });
    },
    /**
     * 切换角色
     * @param {Object} role 角色
     */
    changeRole(role) {
      let params = {
        roleId: role.roleId
      };
      // sku 需要nodeId
      let nodes = role.nodes;
      if (nodes && nodes.length && nodes[0]) {
        Object.assign(params, {
          nodeId: nodes[0].id
        });
      }
      let id = params.roleId
      let roleName = role.roleName
      postWithJson("/changeRole.json", params).then(() => {
      //   if(id===23 || roleName==="二级预算单位负责人" || id===30 || roleName==="二级预算单位预算填报人"){
      //     window.location.href = "/Home/SecondBudgetUnit"
      //     // this.$router.push("/Home/SecondBudgetUnit");
      //   }else if(id===24 || roleName==="一级预算单位负责人" || id===25 || roleName==="一级预算单位财务负责人"
      // || id===22 || roleName==="系统管理员" || id===27 || roleName==="财务总监" || id===29 || roleName==="总裁"){
      //     window.location.href = "/Home/primaryBudgetUnit"
      //     // this.$router.push("/Home/primaryBudgetUnit");
      //   }else{
      //     window.location.href = "/workbench/myProcess/myProcessIndex/myPedding"
      //     // this.$router.push("/workbench/myProcess/myProcessIndex/myPedding");
      //   }
        // window.location.href = "/"; 
        window.location.href = "/myProcess/myProcessIndex/myPedding"
      });
    },
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    /**
     * 退出登录
     */
    logout() {
      window.location.href = "/ac/logout.do";
    },
    // 点击logo回首页
    logoClick() {
      this.$router.push("/");
    },

    // 点击查看更多通知列表
    // viewMoreNotifications() {
    //   this.$router.push("/notificationCenter");
    //   this.$refs.popover.doClose();
    // },

    // 通知点开列表未读数量清空
    // popoverShow() {
    //   // this.$store.commit("SET_UNREAD_NUM", 0);
    //   this.$store.dispatch("getUnreadMessageList");
    // }
  }
};
</script>
<style lang="scss" scoped>
.top-notification-content_list {
  padding: 0px;
}
.top-notification-content_item {
  position: relative;
  padding: 12px;
}
.dot {
  position: absolute;
  top: 18px;
  left: 5px;
  z-index: 999;
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #ff0000;
  border-radius: 5px;
  /* animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite; */
}
.msg-item {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 40px;
  /* padding-top: 4px; */
  white-space: normal;
}
</style>
<style lang="scss">
header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 54px;
  z-index: 9;
  box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.13);
  .logo {
    background-color: #4e7cff;
    font-size: 24px;
    padding: 14px 20px;
    width: 160px;
    height: 54px;
    img {
      display: block;
      width: 133px;
      height: auto;
    }
    &.hideSidebar {
      width: 64px;
      padding: 0;
      img {
        margin: 9px auto;
        width: 34px;
      }
    }
  }
  .top-intro-container {
    background-color: #fff;
    color: #fff;
    padding: 0 30px 0 16px;
    display: flex;
    align-items: center;
    height: 54px;
    justify-content: space-between;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .name {
      display: inline-block;
      color: #666;
      line-height: 100%;
      font-size: 14px;
    }
    .avatar {
      border-radius: 50%;
      margin-right: 8px;
      vertical-align: middle;
    }
    .el-dropdown-trigger {
      cursor: pointer;
    }

    .exit {
      width: 14px;
      height: 14px;
      margin-left: 20px;
    }
    a {
      vertical-align: middle;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .el-badge__content.is-fixed {
    right: 7px;
    font-size: 11px;
    font-weight: bolder;
    padding: 0 5px 0 5px;
    height: 12px;
    line-height: 12px;
    border: 2px solid #fff;
  }
}

.top-notification {
  cursor: pointer;
  width: 14px;
  margin-bottom: 2px;
  height: 14px;

  &-content {
    &_title {
      color: #333;
      padding-bottom: 8px;
      border-bottom: 1px solid #dcdfe6;
    }

    &_list {
      padding: 0 12px;
      max-height: 300px;
      overflow: auto;
    }

    &_item {
      padding: 12px 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      border-bottom: 1px solid #dcdfe6;

      &:last-child {
        border-bottom: none;
      }
    }

    &-bottom {
      cursor: pointer;
      font-size: 12px;
      border-top: 1px solid #dcdfe6;
      padding-top: 12px;
      text-align: center;
    }
  }

  &-nothing {
    &_container {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &_icon {
      text-align: center;
      color: #dadada;
      > svg {
        fill: #dadada;
      }
    }
  }

  > svg {
    fill: rgb(102, 102, 102);
  }
}
.role-item-node {
  margin-left: 3px;
}

</style>
